import '../styles/dashboard.css';
import '../styles/keepgoing.css';
import logo from '../assets/logo.png';
import ProfileDropdown from '../components/ProfileDropdown';
import PortalFaqHelp from '../components/PortalFaqHelp';

export default function KeepGoingPage() {
  // Get user data from localStorage
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const result = JSON.parse(localStorage.getItem('result')) || {};
  const examTitle = result.examTitle || localStorage.getItem('activeExamTitle') || 'your assessment';

  const userName = user.name || 'Candidate';

  // Format time taken
  const formatTime = (seconds) => {
    if (seconds === undefined || seconds === null) return 'N/A';
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  // Format submitted date
  const submittedDate = result.submittedAt ? new Date(result.submittedAt) : new Date();
  const submittedOn = submittedDate.toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric'
  });

  const questionsAttempted = `${result.answeredCount ?? 0} of ${result.totalQuestions ?? 0}`;
  const timeTaken = formatTime(result.timeTaken);

  return (
    <div className="keepgoing-page">

      <nav className="dash-nav">
        <img src={logo} alt="Inteliment Logo" className="dash-logo" />
        <div className="dash-nav-right">
          <PortalFaqHelp />
          <ProfileDropdown user={userName} email={user.email} />
        </div>
      </nav>

      <div className="keepgoing-bg">
        <div className="keepgoing-card">

          {/* LEFT side — circles + trophy */}
          <div className="keepgoing-left">
            <svg className="keepgoing-circles" width="461" height="455" viewBox="0 0 461 455" fill="none">
              <circle cx="157.622" cy="255.692" r="302.802" fill="#DAE6FA" fillOpacity="0.3"/>
              <circle cx="158.244" cy="256.314" r="247.465" fill="#CBDCF8" fillOpacity="0.4"/>
              <circle cx="157.623" cy="255.691" r="183.422" fill="#BCD2F6" fillOpacity="0.3"/>
              <circle cx="158.244" cy="256.313" r="119.38"  fill="#A9C5F3" fillOpacity="0.4"/>
            </svg>

            {/* Trophy icon */}
            {/* Trophy icon */}
            <svg className="keepgoing-trophy" style={{ marginTop: '0px' }} width="132" height="132" viewBox="0 0 132 132" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M123.895 69.6447C125.506 70.388 126.902 71.4486 127.906 72.9609C129.771 75.7681 129.695 79.5737 128.272 82.6291C126.966 85.4332 124.666 87.6635 122.079 89.3779C123.69 90.1212 125.087 91.1818 126.09 92.6941C127.955 95.5013 127.879 99.3069 126.457 102.362C125.211 105.037 123.062 107.189 120.62 108.871C122.209 109.507 123.593 110.463 124.553 111.908C126.13 114.283 126 117.472 124.863 120.086C122.194 126.221 113.605 131.71 94.3722 131.71H63.0774C56.1316 131.71 48.6133 129.137 42.5708 124.262C39.954 122.151 38.4292 118.971 38.4292 115.609V62.3038C38.4292 59.1802 39.7615 56.2191 42.0531 54.0961C49.1202 47.5494 54.0721 36.8923 56.7358 28.03C60.5197 15.4443 53.3296 2.89678 63.9167 0.412577C74.4638 -2.06119 79.6061 7.16579 81.5517 12.7488C86.0168 25.5693 84.7762 40.2498 78.302 52.1731C93.7363 48.9265 101.942 48.1636 116.422 48.1636C121.359 48.1636 126.992 49.1151 129.722 53.2263C131.585 56.0348 131.51 59.8392 130.088 62.8945C128.782 65.7004 126.483 67.9294 123.895 69.6447Z" fill="white"/>
              <path d="M26.5599 126.09H6.11727C2.73893 126.09 0 123.351 0 119.972V60.3172C0 56.9389 2.73893 54.2 6.11727 54.2H26.5599C29.9382 54.2 32.6772 56.9389 32.6772 60.3172V119.972C32.6772 123.351 29.9382 126.09 26.5599 126.09Z" fill="white"/>
            </svg>
            
          </div>

          {/* RIGHT side — text + stats */}
          <div className="keepgoing-right">

            <h1 className="keepgoing-heading">Keep Going, {userName.split(' ')[0]}.</h1>
            <p className="keepgoing-subtitle">Thank You for completing the {examTitle}.</p>
            <p className="keepgoing-body">
              While you have not progressed to the next stage for this role, we truly appreciate the effort and time you invested. Every assessment is a valuable learning step, and each experience helps build future success.
            </p>
            <p className="keepgoing-body" style={{ marginTop: -20 }}>
              Keep growing, keep believing in your potential, and we encourage you to explore upcoming opportunities with us.
            </p>

            {/* Stats row */}
            <div className="keepgoing-stats">
              <div className="keepgoing-stat">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip_kg_time)">
                    <path d="M8.12988 14.9014C11.8707 14.9014 14.9033 11.8688 14.9033 8.12793C14.9033 4.38706 11.8707 1.35449 8.12988 1.35449C4.38902 1.35449 1.35645 4.38706 1.35645 8.12793C1.35645 11.8688 4.38902 14.9014 8.12988 14.9014Z" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8.12988 4.06396V8.12803L10.8393 9.48271" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  </g>
                  <defs>
                    <clipPath id="clip_kg_time">
                      <rect width="16.2563" height="16.2563" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                <span className="keepgoing-stat-label">TIME TAKEN</span>
                <span className="keepgoing-stat-value">{timeTaken}</span>
              </div>

              <div className="keepgoing-stat-divider" />

              <div className="keepgoing-stat">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.03271 2.03174V12.8692C2.03271 13.2285 2.17544 13.5731 2.42949 13.8271C2.68355 14.0812 3.02812 14.2239 3.3874 14.2239H14.2249" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12.1929 11.5147V6.09595" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8.80615 11.5146V3.38647" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M5.41943 11.5147V9.48267" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className="keepgoing-stat-label">QUESTIONS ATTEMPTED</span>
                <span className="keepgoing-stat-value">{questionsAttempted}</span>
              </div>

              <div className="keepgoing-stat-divider" />

              <div className="keepgoing-stat">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.41846 1.35449V4.06387" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10.8374 1.35449V4.06387" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12.8692 2.70923H3.38643C2.63825 2.70923 2.03174 3.31574 2.03174 4.06392V13.5467C2.03174 14.2949 2.63825 14.9014 3.38643 14.9014H12.8692C13.6174 14.9014 14.2239 14.2949 14.2239 13.5467V4.06392C14.2239 3.31574 13.6174 2.70923 12.8692 2.70923Z" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2.03174 6.77319H14.2239" stroke="#26282B" strokeWidth="1.35469" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className="keepgoing-stat-label">SUBMITTED ON</span>
                <span className="keepgoing-stat-value">{submittedOn}</span>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
}
